import React from 'react';
import { decode } from 'helpers/entities';
import { Facility } from 'types/Facility';

interface FacilityInfoProps {
    facility: Facility
}

const FacilityInfo: React.FC<FacilityInfoProps> = ({ facility }) => (
    <>
        {facility.logo_file && (
            <img
                src={facility.logo_file}
                alt={`${facility.facility_name} Auction logo`}
                className="facility-homepage-logo mb-3"
            />
        )}
        <h2 className="custom-h2">{decode(facility?.facility_name || '')}</h2>
        <div className="facility-info-address">
            <p>
                {decode(facility?.address || '')}
                <br />
                {facility.city}{facility.city && ','} {facility.state} {facility.zipcode}
            </p>
        </div>
    </>
);

export default FacilityInfo;
